<app-expandable-section-box
  [title]="'Advertorial Authors'"
  [iconClass]="'icon-folder'"
  [isExpandedByDefault]="isExpandedByDefault"
  [isExpandable]="isExpandable"
>
  <div class="flex flex-col flex-1 py-3" expandedContent>
    <div class="py-1" *ngFor="let item of sponsoredAuthorsControl.value">
      <div class="flex flex-row items-center justify-between">
        <div class="w-full w-8/10">
          {{ item.title }} {{ item.name }} {{ item.companyName }}
        </div>
        <button
          class="px-2 text-base border-none bg-none text-project-100 hover:cursor-pointer hover:text-project-3300 w-1/10"
          data-testid="editBtn"
          title="edit"
          *ngIf="!isEditMode"
          (click)="onEditSponsoredAuthor(item)"
        >
          <i class="icon icon-edit"></i>
        </button>
        <button
          class="text-base border-none bg-none text-project-100 hover:cursor-pointer hover:text-project-2700 w-1/10"
          data-testid="removeBtn"
          title="Remove"
          *ngIf="!isEditMode"
          (click)="onRemove(item)"
        >
          <i class="icon icon-minus-circle"></i>
        </button>
      </div>
    </div>

    <form
      *ngIf="isSponsoredAuthorFormVisible"
      [formGroup]="sponsoredAuthorForm"
      (submit)="addSponsoredAuthor()"
    >
      <mat-form-field appearance="outline" class="w-full">
        <input matInput placeholder="Name" formControlName="name" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-full">
        <input matInput placeholder="Title" formControlName="title" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-full">
        <input matInput placeholder="Company" formControlName="companyName" />
      </mat-form-field>
      <div class="flex w-full py-4 space-x-3">
        <button
          mat-flat-button
          type="submit"
          *ngIf="isNew"
          [disabled]="isSaveButtonDisabled()"
          class="w-full h-8 text-xs font-semibold bg-white border border-solid border-project-100 text-project-500"
        >
          Add author
        </button>
        <button
          mat-flat-button
          type="button"
          *ngIf="!isNew"
          [disabled]="isSaveButtonDisabled()"
          (click)="editSponsoredAuthor()"
          class="w-full h-8 text-xs font-semibold bg-white border border-solid border-project-100 text-project-500"
        >
          Modify
        </button>
        <button
          mat-flat-button
          type="reset"
          (click)="cancelEditAuthorForm()"
          class="w-full h-8 text-xs font-semibold bg-white border border-solid border-project-100 text-project-500"
        >
          Cancel
        </button>
      </div>
    </form>
    <button
      mat-flat-button
      type="button"
      (click)="initSponsoredAuthorForm()"
      *ngIf="!isSponsoredAuthorFormVisible"
      class="h-8 text-xs font-semibold bg-white border border-solid border-project-100 text-project-500"
    >
      Add new sponsored author
    </button>
  </div>
  <div
    notExpandedContent
    *ngIf="sponsoredAuthorsControl.value.length"
    class="py-2"
  >
    <div
      class="text-xs text-project-500"
      *ngFor="let item of sponsoredAuthorsControl.value"
    >
      <p class="text-project-2400">
        {{ item.title }} {{ item.name }} {{ item.companyName }}
      </p>
    </div>
  </div>
</app-expandable-section-box>
